export default class SplitPageElement {
  constructor(options) {
    this.options = options;

    this.learnEditor = options.editor ? options.editor : null;

    this.templates = {
      "splitPageTemplate": [
        "<div id='split-page-element' class='row-fluid split-page-wrapper'>",
          "<h4>Split page</h4>",
          "<div class='form-group'>",
            "<label>New Page Title</label>",
            "<input id='split-page-title' type='text' name='title'>",
          "</div>",
          "<div class='clear'></div>",
          "<div class='editor-buttons'>",
            "<span class='delete'></span>",
            "<button class='form-cancel cancel'>Cancel</button>",
            "<button class='form-submit save'>Split</button>",
          "</div>",
          "<div class='clearfix'></div>",
        "</div>"
      ].join('\n'),
      "splitPageForm": [
          "<form class='split-page-form' method='post' action='" + gon.page_base_url + "/split_page'>",
            "<input type='hidden' name='authenticity_token' value='" + ($('meta[name="csrf-token"]')[0] ? $('meta[name="csrf-token"]')[0].content : "") + "'>",
            "<input type='hidden' name='split_at_position'>",
            "<input type='hidden' name='title'>",
          "</form>"
      ].join('\n')
    }

    this.init();
  }

  init() {
    $(document).on('click', '.split-page-element', $.proxy(this.showForm, this));
    $(document).on('click', '.form-cancel', $.proxy(this.hideForm, this));
    $(document).on('click', '.form-submit', $.proxy(this.splitPage, this));
  }

  shouldShowButton() {
    return $('input[name="page_type"]').val() !== 'user';
  }

  addButtonTemplate() {
    return '<a class="split-page-element" href="#"><i class="fa fa-sort"></i>Split Page</a>';
  }

  showForm(event) {
    var self = this;
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    var $splitPageTemplate = $(this.templates.splitPageTemplate);


    var $activeButtonBar = $(event.target.closest('.button-bar, .bottom-button-bar'));
    $activeButtonBar.replaceWith($splitPageTemplate);

    $splitPageTemplate.show();

    self.learnEditor.center_in_view($splitPageTemplate);
    self.learnEditor.editing();
  }

  hideForm(event) {
    event.preventDefault();

    var $form = $('#split-page-element');
    $form.remove();

    this.learnEditor.finishEditing();
  }

  splitPage(event) {
    event.preventDefault();

    var $form = $(this.templates.splitPageForm);
    if ($('#split-page-element').parent().is('td')) {
      var position = $('#split-page-element').closest('.build-row-button-bar').next('.element').data('position');
    } else {
      var position = $('#split-page-element').next('.element').data('position');
    }
    $form.find('input[name="split_at_position"]').val(position);
    $form.find('input[name="title"]').val($('#split-page-title').val());
    // $form.submit();
    $form.appendTo('body').submit();
  }
}
